module.exports = __webpack_public_path__ + "img/sustainabilityPlatinum.8decf3c.jpg";